module.exports = __webpack_public_path__ + "static/img/curse-introduction.4800832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/curses/curse-introduction.png
// module id = BXgC
// module chunks = 47